import { Injectable, inject } from '@angular/core';

import { SessionStorageService } from '../session-storage/session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class EchoTokenService {
  private sessionStorageService = inject(SessionStorageService);

  private readonly KEY = 'token_echo';

  storeToken(token: string): void {
    this.sessionStorageService.set(this.KEY, token);
  }

  getToken(): string | null {
    return this.sessionStorageService.get(this.KEY);
  }

  hasToken(): boolean {
    return this.sessionStorageService.has(this.KEY);
  }

  clearToken(): void {
    this.sessionStorageService.remove(this.KEY);
  }
}
